import { Component, DoCheck, IterableDiffers, OnInit, ViewChild, HostListener} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { SmmPostService } from '../../../_services/smm-post.service';
import { SmmUserService } from '../../../_services/smm-user.service';
import { GlobalService } from '../../../_services/global.service';
import { SmmService } from 'app/_services/smm.service';
import { ServiceConfig } from 'app/_services/service-config';

const moment = require('moment');

@Component({
  selector: 'app-dashboard4',
  templateUrl: './dashboard4.component.html',
  styleUrls: ['./dashboard4.component.scss']
})


@HostListener('scroll', ['$event'])
export class Dashboard4Component implements OnInit {  
  public msgError = 'LỖI! KHÔNG THỂ KẾT NỐI TỚI MÁY CHỦ';
  projectFilter = false;// Item filter chủ đề
  provinceFilter = true; // Item filter Khu vực
  brandFilter = true; // Item filter thương hiệu
  brandsList = [];
  // Modal
  modalRef: BsModalRef;

  // Tìm kiếm  
  //@ViewChild(DashboardFilterComponent) dashboardFilterComponent: DashboardFilterComponent;

  public dateInput = { start: moment().subtract(1, 'day'), end: moment() };
  public displayDateInput = 0;
  public bgColor = "transparent";

  // Chart Sắc thái thảo luận
  public semiPieChartTitle = "SẮC THÁI THẢO LUẬN";
  public semiPieChartDescription = "";
  public semiPieChartSubTitle = "";
  public semiTypeCounts: Array<number>;
  public semiTypeNames: Array<any>;
  public semiProjectId: Array<any>;
  public dataEmptyDS = false;
  public chartWidthDS = 330;// Độ rộng của chart
  public marginTopDS = 0;// Vị trí của chart so với top
  public listChartDS: Array<any>;// Danh sách các chart theo chủ đề

  // Chart Diễn biến thảo luận (Line-chart)
  public lineChartTitle = "DIỄN BIẾN THẢO LUẬN";
  public typesMapArray: Array<Map<any, any>>;
  public typeNamesDE: Array<any>;
  public dataDE: any;
  public dataEmptyDE = false;
  public listChartDE: Array<any>;// Danh sách các chart theo chủ đề

  // 
  public listPostFB: Array<any>;// Danh sách post FB từng chủ đề
  public listPostArticle: Array<any>;// Danh sách post tin tức (bài báo) từng chủ đề  

  // Danh sách topic cấu hình trong dashboard
  public topicConfig: any;


  constructor(
    private smmPostService: SmmPostService,
    private smmUserService: SmmUserService,
    private globalService: GlobalService,
    private toastrService: ToastrService,    
    private postService: SmmService) {
  
    this.topicConfig = ServiceConfig;
  }

  ngDoCheck(): void {

  }

  ngOnInit(): void {

  }

  /* ================================================ LỰA CHỌN NGÀY HOẶC CHỦ ĐỀ CỦA DASHBOARD FILTER ================================================ */
  loadDashboardData(filterOptions) {  
    this.brandsList = filterOptions.brandsSelected;
    this.loadChartDiscusstionShade(filterOptions);// Sắc thái thảo luận
    this.loadChartDiscusstionEvolution(filterOptions);// Diễn biến thảo luận
    
    this.currentFilter = filterOptions;    
    this.getDataFromServer(filterOptions, ['user_post', 'page_post'], 'news_facebook');// Bài đăng Fanpage mới nhất
    this.getDataFromServer(filterOptions, ['news_article', 'news_forum', 'news_blog'], 'news_article');// Tin bài (báo) mới nhất
  }

  /* ================================================ CHART DIỄN BIẾN THẢO LUẬN - START ================================================ */
  loadChartDiscusstionEvolution(filterOptions) {
    this.listChartDE = [];

    this.dateInput = { start: filterOptions.start, end: filterOptions.end };

    // TODO
    let topicList = this.topicConfig.topicList;
    for (let index = 0; index < this.brandsList.length; index++) { 
      // console.log(topic['id'] + ": " + topic['itemName']);
      // let topic = topicList[index];   
      // let arrTopic = new Array();      
      // arrTopic.push(topic);
      let brandItem = this.brandsList[index];

      this.smmPostService.searchPostsDiscussionEvolution({
        size: 0,
        filter: {
          lte: filterOptions.lte,
          gte: filterOptions.gte,
          notSpam : filterOptions.notSpam,
          brandsSelected : [brandItem],
          // projects: filterOptions.projects,
          // projects: arrTopic,
          provinces: filterOptions.provinces,
          index : 'full'
        }
      }).subscribe(response => {
        // TODO
        let objLine = {
          typeNamesDE: [],
          typesMapArray: [],          
          lineProjectId: [],
          lineChartTitle: this.lineChartTitle,
          topicName: brandItem['itemName'],
          dataEmptyDE: true,            
        }

        if (response.success) {
          const data = response.data;

          this.typesMapArray = [];
          this.typeNamesDE = [];
          this.dataDE = data.aggregations.byday.buckets;
          for (let index = 0; index < this.dataDE.length; index++) {
            const element = this.dataDE[index];
            const tempMap = new Map();
            tempMap.set(element.key, [element.doc_count]);
            this.typesMapArray.push(tempMap);
          }
          // console.log(this.typesMapArray);
          if (this.typesMapArray.length > 0) {
            this.dataEmptyDE = false;
            // this.typeNamesDE.push(filterOptions.projects[0].value);
            this.typeNamesDE.push(brandItem['itemName']);
          } else {
            this.dataEmptyDE = true;
            this.typesMapArray = [];
          }

          // TODO
          objLine.typesMapArray = this.typesMapArray;
          objLine.typeNamesDE = this.typeNamesDE;
          objLine.lineProjectId = brandItem['id'].split();
          objLine.dataEmptyDE = this.dataEmptyDE;
        } else {
          this.dataEmptyDE = true;
          this.typesMapArray = [];
          objLine.dataEmptyDE = this.dataEmptyDE;
        }

        this.listChartDE.push(objLine);
        this.listChartDE.sort(function(a,b) {return (a.topicName > b.topicName) ? 1 : ((b.topicName > a.topicName) ? -1 : 0);} );

      }, error => {
        this.dataEmptyDE = true;
        this.typesMapArray = [];
      });
    }
  }
  /* ================================================ CHART DIỄN BIẾN THẢO LUẬN - END ================================================ */

  /* ================================================ CHART SẮC THÁI THẢO LUẬN - START ================================================ */
  loadChartDiscusstionShade(filterOptions) {
    this.listChartDS = [];  
    // console.log(filterOptions);
    // Hôm nay
    let todayStart = moment().startOf('day').valueOf();
    let todayEnd = moment().endOf('day').valueOf();

    // Hôm qua
    let yesterdayStart = moment().subtract(1, 'day').startOf('day').valueOf();
    let yesterdayEnd = moment().subtract(1, 'day').endOf('day').valueOf();

    // Tuần này
    let thisWeekStart = moment().startOf('isoWeek').valueOf();
    let thisWeekEnd = moment().endOf('isoWeek').valueOf();

    // Tuần trước
    let lastWeekStart = moment().subtract(1, 'week').startOf('isoWeek').valueOf();
    let lastWeekEnd = moment().subtract(1, 'week').endOf('isoWeek').valueOf();

    // Nếu chọn Hôm nay
    let filterDate = { lte: null, gte: null };
    let flagDate = 0;
    if ((filterOptions.gte == todayStart && filterOptions.lte == todayEnd) || (filterOptions.label == "Hôm nay")) {
      filterDate.lte = yesterdayEnd;
      filterDate.gte = yesterdayStart;
      flagDate = 1;
      // console.log("Chọn hôm nay");
      // console.log(filterDate);
    }
    // Nếu chọn Tuần này    
    else if ((filterOptions.gte == thisWeekStart && filterOptions.lte == thisWeekEnd) || (filterOptions.label == "Tuần này")) {
      filterDate.lte = lastWeekEnd;
      filterDate.gte = lastWeekStart;
      flagDate = 2;
      // console.log("Chọn tuần này");      
      // console.log(filterDate);
    }

    //
    this.dateInput = { start: filterOptions.start, end: filterOptions.end };

    // TODO
    // let topicList = this.topicConfig.topicList;
    for (let index = 0; index < this.brandsList.length; index++) { 

     
      let brandItem = this.brandsList[index];

      // let topic = topicList[index];   
      // let arrTopic = new Array();      
      // arrTopic.push(topic);

      // GỌI API
      this.smmPostService.searchDiscussionShade({
        size: 0,
        filter: {
          lte: filterOptions.lte,
          gte: filterOptions.gte,
          // projects: filterOptions.projects,
          // projects: arrTopic,
          brandsSelected : [brandItem],
          provinces: filterOptions.provinces,
          notSpam : filterOptions.notSpam,
          index : 'full'
        }
      }).subscribe(response => {
        // TODO
        let objSemi = {
          semiTypeCounts: [],
          semiTypeNames: [],
          semiProjectId: [],
          semiPieChartTitle: this.semiPieChartTitle,
          topicName: brandItem['itemName'],
          semiPieChartDescription: "",
          semiPieChartSubTitle: "",
          dataEmptyDS: true,            
        }   

        if (response.success) {
          // response.success == true
          const data = response.data;
          const aggregations = data.aggregations;
          
          
          // POST
          let post = aggregations.Post;
          let totalPost: number = post.doc_count == undefined ? 0 : post.doc_count;
          let likePost: number = post.likeCount.value == undefined ? 0 : post.likeCount.value;
          let sentimentPost = post.sentimentsCount.statistic.seg.buckets; // array
          let sentimentNegPost: number = 0;
          let sentimentPosPost: number = 0;
          let sentimentNeuPost: number = 0;
          let totalSentimentPost: number = 0;
          for (var i = 0; i < sentimentPost.length; i++) {
            if (sentimentPost[i].key == "neg") {
              sentimentNegPost = sentimentPost[i].doc_count;
              totalSentimentPost += sentimentNegPost;
            }
            else if (sentimentPost[i].key == "pos") {
              sentimentPosPost = sentimentPost[i].doc_count;
              totalSentimentPost += sentimentPosPost;
            }
            else if (sentimentPost[i].key == "neu") {
              sentimentNeuPost = sentimentPost[i].doc_count;
              totalSentimentPost += sentimentNeuPost;
            }
          }

          // NEWS (BÀI BÁO)
          let news = aggregations.News;
          let totalNews: number = news.doc_count == undefined ? 0 : news.doc_count;
          let likeNews: number = news.likeCount.value == undefined ? 0 : news.likeCount.value;
          let sentimentNews = news.sentimentsCount.statistic.seg.buckets; // array
          let sentimentNegNews: number = 0;
          let sentimentPosNews: number = 0;
          let sentimentNeuNews: number = 0;
          let totalSentimentNews: number = 0;
          for (var i = 0; i < sentimentNews.length; i++) {
            if (sentimentNews[i].key == "neg") {
              sentimentNegNews = sentimentNews[i].doc_count;
              totalSentimentNews += sentimentNegNews;
            }
            else if (sentimentNews[i].key == "pos") {
              sentimentPosNews = sentimentNews[i].doc_count;
              totalSentimentNews += sentimentPosNews;
            }
            else if (sentimentNews[i].key == "neu") {
              sentimentNeuNews = sentimentNews[i].doc_count;
              totalSentimentNews += sentimentNeuNews;
            }
          }

          // COMMENT
          let comment = aggregations.Comment;
          let totalComment: number = comment.doc_count == undefined ? 0 : comment.doc_count;
          let likeComment: number = comment.likeCount.value == undefined ? 0 : comment.likeCount.value;
          let sentimentComment = comment.sentimentsCount.statistic.seg.buckets; // array
          let sentimentNegComment: number = 0;
          let sentimentPosComment: number = 0;
          let sentimentNeuComment: number = 0;
          let totalSentimentComment: number = 0;
          for (var i = 0; i < sentimentComment.length; i++) {
            if (sentimentComment[i].key == "neg") {
              sentimentNegComment = sentimentComment[i].doc_count;
              totalSentimentComment += sentimentNegComment;
            }
            else if (sentimentComment[i].key == "pos") {
              sentimentPosComment = sentimentComment[i].doc_count;
              totalSentimentComment += sentimentPosComment;
            }
            else if (sentimentComment[i].key == "neu") {
              sentimentNeuComment = sentimentComment[i].doc_count;
              totalSentimentComment += sentimentNeuComment;
            }
          }

          // PUSH DATA CHART
          this.semiTypeNames = [];
          this.semiTypeCounts = [];
          this.semiProjectId = [];
          this.semiPieChartDescription = "";

          let countPos: number = sentimentPosPost + sentimentPosNews + sentimentPosComment;
          let countNeg: number = sentimentNegPost + sentimentNegNews + sentimentNegComment;
          let countNeu: number = sentimentNeuPost + sentimentNeuNews + sentimentNeuComment;
          // let totalSentiment: number = countPos + countNeu + countNeg;

          this.semiTypeNames.push("Tích cực");
          this.semiTypeNames.push("Trung tính");
          this.semiTypeNames.push("Tiêu cực");

          if (countPos > 0) {
            this.semiTypeCounts.push(countPos);
            this.semiProjectId.push(brandItem['id']);
          }else{
            this.semiTypeCounts.push(0);
            this.semiProjectId.push(brandItem['id']);
          }

          if (countNeu > 0) {          
            this.semiTypeCounts.push(countNeu);
            this.semiProjectId.push(brandItem['id']);
          }else{
            this.semiTypeCounts.push(0);
            this.semiProjectId.push(brandItem['id']);
          }

          if (countNeg > 0) {          
            this.semiTypeCounts.push(countNeg);
            this.semiProjectId.push(brandItem['id']);
          }else{
            this.semiTypeCounts.push(0);
            this.semiProjectId.push(brandItem['id']);
          }          

          let totalLike: number = likePost + likeNews + likeComment;
          let totalBuzz: number = totalSentimentPost + totalSentimentNews + totalSentimentComment + totalLike;
          if (totalSentimentPost == 0 && totalSentimentNews == 0 && totalSentimentComment == 0 && totalLike == 0) {
            this.semiPieChartDescription = "";
            this.dataEmptyDS = true;
            this.semiTypeNames = [];
            this.semiTypeCounts = [];
            this.semiProjectId = [];
          } else {
            this.dataEmptyDS = false;
            this.semiPieChartDescription = "Tổng số: " + totalBuzz +
                                        "<br>Bài viết: " + totalSentimentPost +
                                        "<br>Báo chí: " + totalSentimentNews +
                                        "<br>Bình luận: " + totalSentimentComment +
                                        "<br>Lượt thích: " + totalLike;
          }

          // TODO
          objSemi.semiTypeCounts = this.semiTypeCounts;
          objSemi.semiTypeNames = this.semiTypeNames;
          objSemi.semiProjectId = this.semiProjectId;
          objSemi.semiPieChartDescription = this.semiPieChartDescription;          
          objSemi.dataEmptyDS = this.dataEmptyDS;

          /* ============================== SO SÁNH CÙNG KỲ - START ==============================*/
          if (flagDate == 1 || flagDate == 2) {
            this.smmPostService.searchDiscussionShade({
              size: 0,
              filter: {
                lte: filterDate.lte,
                gte: filterDate.gte,
                brandsSelected : [brandItem],
                // projects: filterOptions.projects,
                // projects: arrTopic,
                provinces: filterOptions.provinces,
                index : 'full'
              }
            }).subscribe(response => {
              if (response.success) {
                // console.log("==================");
                const data = response.data;
                const aggregations = data.aggregations;

                // POST
                let post = aggregations.Post;
                let sentimentPost = post.sentimentsCount.statistic.seg.buckets; // array
                let sentimentNegPost = 0;
                let sentimentPosPost = 0;
                let sentimentNeuPost = 0;
                let totalSentimentPost = 0;
                for (var i = 0; i < sentimentPost.length; i++) {
                  if (sentimentPost[i].key == "neg") {
                    sentimentNegPost = sentimentPost[i].doc_count;
                    totalSentimentPost += sentimentNegPost;
                  }
                  else if (sentimentPost[i].key == "pos") {
                    sentimentPosPost = sentimentPost[i].doc_count;
                    totalSentimentPost += sentimentPosPost;
                  }
                  else if (sentimentPost[i].key == "neu") {
                    sentimentNeuPost = sentimentPost[i].doc_count;
                    totalSentimentPost += sentimentNeuPost;
                  }
                }

                // NEWS
                let news = aggregations.News;
                let sentimentNews = news.sentimentsCount.statistic.seg.buckets; // array
                let sentimentNegNews = 0;
                let sentimentPosNews = 0;
                let sentimentNeuNews = 0;
                let totalSentimentNews = 0;
                for (var i = 0; i < sentimentNews.length; i++) {
                  if (sentimentNews[i].key == "neg") {
                    sentimentNegNews = sentimentNews[i].doc_count;
                    totalSentimentNews += sentimentNegNews;
                  }
                  else if (sentimentNews[i].key == "pos") {
                    sentimentPosNews = sentimentNews[i].doc_count;
                    totalSentimentNews += sentimentPosNews;
                  }
                  else if (sentimentNews[i].key == "neu") {
                    sentimentNeuNews = sentimentNews[i].doc_count;
                    totalSentimentNews += sentimentNeuNews;
                  }
                }

                // COMMENT
                let comment = aggregations.Comment;
                let sentimentComment = comment.sentimentsCount.statistic.seg.buckets; // array
                let sentimentNegComment = 0;
                let sentimentPosComment = 0;
                let sentimentNeuComment = 0;
                let totalSentimentComment = 0;
                for (var i = 0; i < sentimentComment.length; i++) {
                  if (sentimentComment[i].key == "neg") {
                    sentimentNegComment = sentimentComment[i].doc_count;
                    totalSentimentComment += sentimentNegComment;
                  }
                  else if (sentimentComment[i].key == "pos") {
                    sentimentPosComment = sentimentComment[i].doc_count;
                    totalSentimentComment += sentimentPosComment;
                  }
                  else if (sentimentComment[i].key == "neu") {
                    sentimentNeuComment = sentimentComment[i].doc_count;
                    totalSentimentComment += sentimentNeuComment;
                  }
                }

                // SO SÁNH
                let countPos: number = sentimentPosPost + sentimentPosNews + sentimentPosComment;
                let countNeg: number = sentimentNegPost + sentimentNegNews + sentimentNegComment;
                let countNeu: number = sentimentNeuPost + sentimentNeuNews + sentimentNeuComment;
                if (countPos == 0 && countNeu == 0 && countNeg == 0) {
                  this.semiPieChartSubTitle = "";
                } else {
                  let totalSentiment: number = countPos + countNeu + countNeg;
                  let posPercent = this.roundTo(countPos * 100 / totalSentiment, 2);
                  let neuPercent = this.roundTo(countNeu * 100 / totalSentiment, 2);
                  let negPercent = this.roundTo(100 - (parseFloat(posPercent) + parseFloat(neuPercent)), 2);

                  this.semiPieChartSubTitle = "";
                  if (flagDate == 1) {
                    this.semiPieChartSubTitle += "Hôm qua: ";
                  } else if (flagDate == 2) {
                    this.semiPieChartSubTitle += "Tuần trước: ";
                  }
                  this.semiPieChartSubTitle += "Tích cực: " + posPercent
                                            + "%, Trung tính: " + neuPercent
                                            + "%, Tiêu cực: " + negPercent + "%";
                }

                // TODO
                objSemi.semiPieChartSubTitle = this.semiPieChartSubTitle;
              }
            }, error => {
              this.dataEmptyDS = true;
            });
          } else {
            this.semiPieChartSubTitle = "";
          }
          /* ============================== SO SÁNH CÙNG KỲ - END ==============================*/
        } else {
          // response.success == false
          this.dataEmptyDS = true;
          this.semiTypeNames = [];
          this.semiTypeCounts = [];
          this.semiProjectId = [];
        }

        this.listChartDS.push(objSemi);
        this.listChartDS.sort(function(a,b) {return (a.topicName > b.topicName) ? 1 : ((b.topicName > a.topicName) ? -1 : 0);} );

        
      }, error => {
        // error
        this.dataEmptyDS = true;
        this.semiTypeNames = [];
        this.semiTypeCounts = [];
        this.semiProjectId = [];
      });

    }
  }
  /* ================================================ CHART SẮC THÁI THẢO LUẬN - END ================================================ */

  /* ================================================ BÀI ĐĂNG, TIN TỨC MỚI NHẤT - START ========================================================  */
  currentFilter = null;

  getHostname(url) {
    return new URL(url).hostname;
  }
  getPostFacebookUrl(docId) {
    return `https://facebook.com/${docId}`
  }

  getDataFromServer(filter, docType, mode, from = 0) {
    // console.log(filter);
    this.listPostFB = [];
    this.listPostArticle = [];

    let topicList = this.topicConfig.topicList;

  //  for (let index = 0; index < topicList.length; index++) {      
   for (let index = 0; index < this.brandsList.length; index++) { 

     
      let brandItem = this.brandsList[index];
      //let topic = topicList[index];   
      // let arrTopic = new Array();      
      // arrTopic.push(brandItem);

      filter.brandsSelected = [this.brandsList[index]];

     

      let pageId = "";
      if(mode == 'news_facebook'){
        pageId = brandItem['fanpageId'] || 'unique_id';
      }else if(mode == 'news_article'){
        pageId = null;
      }

      let body = {
        filter: Object.assign({},filter),
        docType: docType,
        isNegativePost: (mode == 'negativeFaceBook' || mode == 'news_article_negative') ? true : false,
        size: 20,
        from: from,
        mode: mode,
        pageId: pageId
      }

      if(mode == 'news_article' || mode == 'news_article_negative') {
        delete body.filter['provinces'];
      }

      this.postService.getRecentPost(body).subscribe(res => {
        let obj = {
          newsArticle: [],  
          newsFacebook: [],
          topicName: brandItem['itemName'],
          topicId: brandItem['id'],
          topic: [brandItem],
          isButtonLoading: false,
          resultCount: 0
        }      
        if (res.success) {
          if(res.data.hits.hits.length > 0){
            switch (mode) {
              case 'news_facebook':              
                obj.newsFacebook = res.data.hits.hits;  
                obj.resultCount = res.data.hits.total.value;
                this.listPostFB.push(obj);
                this.listPostFB.sort(function(a,b) {return (a.topicName > b.topicName) ? 1 : ((b.topicName > a.topicName) ? -1 : 0);} );            
                break;
              case 'news_article':              
                obj.newsArticle = res.data.hits.hits;
                obj.resultCount = res.data.hits.total.value; 
                this.listPostArticle.push(obj);
                this.listPostArticle.sort(function(a,b) {return (a.topicName > b.topicName) ? 1 : ((b.topicName > a.topicName) ? -1 : 0);} );                       
                break;
              default:
                break;
            }
          }else{
            if(mode == "news_facebook"){
              this.listPostFB.push(obj);
              
            }else if(mode = "news_article"){
              this.listPostArticle.push(obj);
            }
          }
        }else{
          if(mode == "news_facebook"){
            this.listPostFB.push(obj);
          }else if(mode = "news_article"){
            this.listPostArticle.push(obj);
          }
        }
        this.listPostFB.sort(function(a,b) {return (a.topicName > b.topicName) ? 1 : ((b.topicName > a.topicName) ? -1 : 0);} );            
        this.listPostArticle.sort(function(a,b) {return (a.topicName > b.topicName) ? 1 : ((b.topicName > a.topicName) ? -1 : 0);} );                       

      });

    }
  }

  // Nhấn nút xem thêm
  loadMore(mode, from, topic = []) {       
    let docType = [];
    if(mode == "news_facebook"){
      docType = ['user_post', 'group_post', 'page_post'];
    }else if(mode == "news_article"){
      docType = ['news_article','news_forum', 'news_blog'];
    }

    this.currentFilter.brandsSelected = topic;

    let body = {
      filter: this.currentFilter,
      docType: docType,
      isNegativePost: (mode == 'negativeFaceBook' || mode == 'news_article_negative') ? true : false,
      size: 20,
      from: from,
      mode: mode,
      pageId: mode == 'news_facebook' ? topic[0].fanpageId  :  null
    }

    this.postService.getRecentPost(body).subscribe(res => {
      if (res.success && res.data.hits.hits.length > 0) {
        switch (mode) {
          case 'news_facebook':
            this.listPostFB.forEach((element , _idx) => {
              if (element.topicId == topic[0].id) {
                this.listPostFB[_idx].isButtonLoading = true;
                this.listPostFB[_idx].newsFacebook =  this.listPostFB[_idx].newsFacebook.concat(res.data.hits.hits);
                this.listPostFB[_idx].resultCount = res.data.hits.total.value;
                setTimeout(() => {
                  this.listPostFB[_idx].isButtonLoading = false;
                }, 1000);
                return;
              }
            })
            break;
          case 'news_article':
            this.listPostArticle.forEach((element , _idx) => {
              if (element.topicId == topic[0].id) {
                this.listPostArticle[_idx].isButtonLoading = true;
                this.listPostArticle[_idx].newsArticle =  this.listPostArticle[_idx].newsArticle.concat(res.data.hits.hits);
                setTimeout(() => {
                  this.listPostArticle[_idx].isButtonLoading = false;
                }, 1000);
                return;
              }
            })
            break;
          default:
            break;
        }
        
      }else{
        // Không có dữ liệu trả về
      }

      

    });
  }

  onScroll(event: any, mode, from, topic = []) {    
    if (event.target.scrollTop != 0 && event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
      let docType = [];
      if(mode == "news_facebook"){
        docType = ['user_post', 'group_post', 'page_post'];
      }else if(mode == "news_article"){
        docType = ['news_article','news_forum', 'news_blog'];
      }

      this.currentFilter.brandsSelected = topic;

      let body = {
        filter: this.currentFilter,
        docType: docType,
        isNegativePost: (mode == 'negativeFaceBook' || mode == 'news_article_negative') ? true : false,
        size: 10,
        from: from,
        mode: mode
      }

      this.postService.getRecentPost(body).subscribe(res => {
        if (res.success && res.data.hits.hits.length > 0) {
          switch (mode) {
            case 'news_facebook':
              this.listPostFB.forEach((element , _idx) => {
                if (element.topicId == topic[0].id ) {
                  this.listPostFB[_idx].newsFacebook =  this.listPostFB[_idx].newsFacebook.concat(res.data.hits.hits);
                  return;
                }
              })
              break;
            case 'news_article':
              this.listPostArticle.forEach((element , _idx) => {
                if (element.topicId == topic[0].id ) {
                  this.listPostArticle[_idx].newsArticle =  this.listPostArticle[_idx].newsArticle.concat(res.data.hits.hits);
                  return;
                }
              })
              break;
            default:
              break;
          }
          
        }else{
          
        }
      });
    }
  }

  /* ================================================ BÀI ĐĂNG, TIN TỨC MỚI NHẤT - END ========================================================  */



  /* ================================================ COMMON FUNCTION - START ========================================================  */
  public capitalizeName(name) {
    return name.replace(/\b(\w)/g, s => s.toUpperCase());
  }

  public add(a, b) {
    return a + b;
  }

  public roundTo(n, digits) {
    var negative = false;
    if (digits === undefined) {
      digits = 0;
    }
    if (n < 0) {
      negative = true;
      n = n * -1;
    }
    var multiplicator = Math.pow(10, digits);
    n = parseFloat((n * multiplicator).toFixed(11));
    n = (Math.round(n) / multiplicator).toFixed(2);
    if (negative) {
      n = (n * -1).toFixed(2);
    }
    return n;
  }
  /* ================================================ COMMON FUNCTION - END ========================================================  */
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard4/dashboard4.component.ts